import React from "react";
import classes from "./Loading.scss";
import loadingsvg from "./loading.svg";
import classNames from "classnames";
import PropTypes from "prop-types";

const Loading = props => {
  const { position, loadingStyle, containerStyle, isMiniLoader } = props;
  var containerClass = classNames(
    position == "center-bottom" ? classes.containerBottomCenter : null,
    position == "center" ? classes.containerCenter : null
  );

  const loadingImgClasses = classNames({
    [classes.loadingImg]: true,
    [classes.miniLoaderImg]: isMiniLoader, // These styles apply when this loader is used in 2.0 revamped modals.
  });

  return (
    <div className={containerClass} style={containerStyle}>
      <img
        className={loadingImgClasses}
        style={loadingStyle}
        src={loadingsvg}
        alt=""
      />
    </div>
  );
};

Loading.propTypes = {
  containerStyle: PropTypes.object,
  loadingStyle: PropTypes.object,
  position: PropTypes.string,
  isMiniLoader: PropTypes.bool,
};

Loading.defaultProps = {
  position: "center",
  loadingStyle: {},
  containerStyle: {},
  isMiniLoader: false,
};

export default Loading;
